import React, { Component } from 'react'
import DataImport from './DataImport'
import Ladder from './Ladder'
import Scores from './Scores'
import Buttons from './Buttons'
import Experts from './Experts'
import { FiLink } from 'react-icons/fi'
import pkgInfo from '../package.json'

class App extends Component {

	constructor(props) {
		super(props)
		this.state = {
			amDragging: false,
			year: null,
			showExperts: false,
		}
		this.computeLadderOrder = this.computeLadderOrder.bind(this)
		this.reset = this.reset.bind(this)
		this.randomize = this.randomize.bind(this)
		this.reverse = this.reverse.bind(this)
		this.onYearChange = this.onYearChange.bind(this)
	}

	componentDidMount() {
		const search = window.location.search
		const params = new URLSearchParams(search)
		let year = Number(params.get('y'))

		if (year < 2012) {
			const d = new Date()
			const month = d.getMonth()
			year = d.getFullYear()

			if (month >= 10) {
				year += 1
			}
		}

		const newState = {
			year,
		}

		const q = params.get('q');
		if (q && q.length === 22) {
			const customYear = Number(q.substr(0, 4))
			if (customYear >= 2012 && customYear <= year) {
				newState.year = customYear
			}

			const customOrder = q.substr(4).split('').map(chr => chr.charCodeAt(0) - 96 )
			//
			// Check this seems valid
			//
			const uniqueItems = [...new Set(customOrder)]
			if (uniqueItems.filter(n => n >= 1 && n <= 18).length === 18) {
				newState.order = customOrder
			}
		}

		const showExperts = params.get('experts')
		newState.showExperts = showExperts ? true : false
		if (showExperts) {
			if (showExperts > 1900) {
				newState.year = showExperts
			} else {
				newState.year = 2019
			}
		}

		this.setState(newState)
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.year !== this.state.year) {
			DataImport(this.state.year).then((data) => {
				this.setState(data)
				this.computeLadderOrder({
					newOrder: this.state.order
				})
			})
		}
	}

	//
	// newOrder: (Optional) what the new order should be
	// arg2    :
	// arg3 is the 'onMove' event from Sortable
	//
	computeLadderOrder(args) {

		const { newOrder, event } = args
		const { order, teams } = this.state

		let amDragging = false

		// console.log('computeLadderOrder', newOrder, event)

		const newState = { }

		if (newOrder) {
			newState.order = newOrder
		} else {
			if (event) {
				if (event.dragged) {

					const teamId = Number(event.dragged.dataset.id)
					const otherTeams = order.filter(id => Number(id) !== teamId)
					const idx = Number(event.related.dataset.liverank)

					newState.order = [].concat(otherTeams.slice(0, idx), [ teamId ], otherTeams.slice(idx))

					amDragging = true
				}
			} else {
				//
				// Rely on 'rank' value built by DataImport.js, which draws on prev year if necessary
				// (ie when looking into the future).
				//
				newState.order = Object.values(teams).sort((a, b) => a.rank - b.rank).map( team => team.id )
			}
		}

		if (!amDragging) {
			newState.officialOrder = newOrder || newState.order
		}

		this.setState(newState)
	}

	reset() {
		this.computeLadderOrder({ })
	}

	randomize() {
		const newOrder = this.state.order.slice()

		const SIMS = 1

		for (let k = 0; k < SIMS; k++) {

			for (let i = newOrder.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1))
				const temp = newOrder[i]
				newOrder[i] = newOrder[j]
				newOrder[j] = temp
			}

		}

		this.computeLadderOrder({
			newOrder,
		})
	}

	onYearChange(event) {
		this.setState({
			year: Number(event.target.value),
		})
	}

	boink() {
		const arr = [ ]

		for (let i = 0; i <= 100; i++) {
			let count = 0
			this.state.random_mae.forEach(n => {
				if (i === Math.floor(n)) {
					count += 1
				}
			})
			arr[i] = count
		}

		console.log('Randomness:', arr.join(','))
	}

	reverse() {
		const { order } = this.state
		const newOrder = order.slice().reverse()
		this.computeLadderOrder({
			newOrder,
		})
	}

	render()
	{
		const permalink = generatePermalink(this.state.year, this.state.order)

		const hoverText = ("ontouchstart" in document.documentElement) ? 'Tap' : 'Hover over'

		if (this.state.showExperts) {
			return (
				<Experts
					year={this.state.year}
					teams={this.state.teams}
					standings={this.state.standings}
				/>
			)
		}

		const showExpertsButton = this.state.year >= 2019 && (
			<p className="permalink-box">
				<a className="permalink" href={`?experts=${this.state.year}`}>
					Show Experts in {this.state.year}
				</a>
			</p>
		)

		const { version } = pkgInfo

		return (
			<div id="lscore" className="App">
				<p className="smalltext">
					How accurate was your ladder prediction? Drag teams to where you
					tipped them to finish, then check your score.
				</p>
				<Buttons
					onReset={this.reset}
					onRandomize={this.randomize}
					onReverse={this.reverse}
					onYearChange={this.onYearChange}
					year={this.state.year}
				/>
				<section id="lscore-content">
					<Ladder
						teams={this.state.teams}
						standings={this.state.standings}
						order={this.state.order}
						officialOrder={this.state.officialOrder}
						onMove={this.computeLadderOrder}
					year={this.state.year}
					/>
					<Scores
						year={this.state.year}
						order={this.state.order}
						teams={this.state.teams}
						standings={this.state.standings}
					/>
				</section>
				<section className="info-text">
					<p className="permalink-box">
						<a className="permalink" href={permalink}>
							<FiLink /> Permanent link to this ladder
						</a>
					</p>
					{showExpertsButton}
					<p className="smalltext">
						{hoverText} a score category for more info.
					</p>
					<p className="smalltext">
						<b>Score</b> is AE plus MSE with a bonus 1pt for each Exactly Right
						and bonus 2pts for each correct Minor Premier, Wooden Spoon, Top 4, and Finalist (Top 8 for 2025 and earlier, Top 10 for 2026+).
						This is scaled from 0 to 100.
					</p>
					<p className="versiontext smalltext">
						Version {version}
					</p>
				</section>
			</div>
		)
	}
}

function generatePermalink(year, order) {
	if (!year || !order)
		return null

	return '//' + window.location.host + window.location.pathname + '?q=' + year + order.map( n => String.fromCharCode(96 + Number(n))).join('')
}

export default App
